/* Eleanor Cheltenham — product page: variant selection, gallery sync, sticky CTA, add to cart. */
(function () {
  'use strict';

  document.querySelectorAll('[data-product-form]').forEach(function (root) {
    var productId = root.getAttribute('data-product-id');
    var variantsJson = root.querySelector('[data-variants-json]');
    var variants = variantsJson ? (JSON.parse(variantsJson.textContent).variants || []) : [];
    var optionInputs = root.querySelectorAll('[data-option-input]');
    var variantIdInput = root.querySelector('[data-variant-id-input]');
    var priceEl = root.querySelector('[data-current-price]');
    var comparePriceEl = root.querySelector('[data-compare-price]');
    var addBtn = root.querySelector('[data-add-to-cart]');
    var buyNowWrap = root.querySelector('[data-buy-now]');
    var soldOutLabel = root.querySelector('[data-sold-out-label]');
    var gallery = document.querySelector('[data-product-gallery]');

    function currentSelection() {
      var sel = {};
      optionInputs.forEach(function (input) {
        if (input.type === 'radio' && !input.checked) return;
        sel[input.getAttribute('data-option-name')] = input.value;
      });
      return sel;
    }

    function findMatchingVariant() {
      var sel = currentSelection();
      return variants.find(function (v) {
        return Object.keys(sel).every(function (k) { return v.options[k] === sel[k]; });
      });
    }

    function formatMoney(cents) {
      return '£' + (cents / 100).toFixed(2);
    }

    function updateAvailability() {
      var sel = currentSelection();
      optionInputs.forEach(function (input) {
        if (input.type !== 'radio') return;
        var testSel = Object.assign({}, sel);
        testSel[input.getAttribute('data-option-name')] = input.value;
        var matches = variants.filter(function (v) {
          return Object.keys(testSel).every(function (k) { return v.options[k] === testSel[k]; });
        });
        var anyAvailable = matches.some(function (v) { return v.available; });
        input.disabled = matches.length > 0 && !anyAvailable;
      });
    }

    function updateUI() {
      var variant = findMatchingVariant();
      updateAvailability();
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.getAttribute('data-label-unavailable') || 'Unavailable'; }
        if (buyNowWrap) buyNowWrap.hidden = true;
        return;
      }
      if (variantIdInput) variantIdInput.value = variant.id;
      var selection = currentSelection();
      root.querySelectorAll('[data-selected-value]').forEach(function (el) {
        var optionName = el.getAttribute('data-option-name');
        if (optionName && selection[optionName] != null) el.textContent = selection[optionName];
      });
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price);
          comparePriceEl.hidden = false;
        } else {
          comparePriceEl.hidden = true;
        }
      }
      var stickyPrice = document.querySelector('[data-sticky-price]');
      var stickyButton = document.querySelector('[data-sticky-add-to-cart]');
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      if (stickyButton) {
        stickyButton.disabled = !variant.available;
        stickyButton.textContent = variant.available
          ? (addBtn && addBtn.getAttribute('data-label-default') || 'Add to Bag')
          : (addBtn && addBtn.getAttribute('data-label-soldout') || 'Sold Out');
      }

      if (variant.available) {
        if (addBtn) { addBtn.disabled = false; addBtn.textContent = addBtn.getAttribute('data-label-default') || 'Add to Bag'; }
        if (buyNowWrap) buyNowWrap.hidden = false;
        if (soldOutLabel) soldOutLabel.hidden = true;
      } else {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.getAttribute('data-label-soldout') || 'Sold Out'; }
        if (buyNowWrap) buyNowWrap.hidden = true;
        if (soldOutLabel) soldOutLabel.hidden = false;
      }

      if (gallery && variant.featured_media_position != null) {
        gallery.dispatchEvent(new CustomEvent('gallery:goto', { detail: { position: variant.featured_media_position, behavior: 'auto' } }));
      }

      root.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: variant }, bubbles: true }));
      window.EleanorAnalytics && EleanorAnalytics.track('select_variant', { productId: productId, variantId: variant.id });
    }

    optionInputs.forEach(function (input) { input.addEventListener('change', updateUI); });
    // Let the gallery register its event listener before the first variant sync.
    // This is essential when a product's initially selected variant does not use image 1.
    window.setTimeout(updateUI, 0);

    var qtyInput = root.querySelector('[data-qty-input]');
    root.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!qtyInput) return;
        var step = parseInt(btn.getAttribute('data-qty-step'), 10);
        var next = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + step);
        qtyInput.value = next;
      });
    });

    var form = root.querySelector('form[action*="/cart/add"]');
    if (form && addBtn) {
      form.addEventListener('submit', function (e) {
        if (!e.submitter || !e.submitter.matches('[data-add-to-cart]')) return;
        e.preventDefault();
        addBtn.classList.add('btn--loading');
        addBtn.disabled = true;
        var formData = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
          .then(function (res) { if (!res.ok) throw new Error('add_to_cart_failed'); return res.json(); })
          .then(function (item) {
            window.EleanorAnalytics && EleanorAnalytics.track('add_to_cart', { productId: productId, variantId: item.variant_id, quantity: item.quantity });
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            document.dispatchEvent(new CustomEvent('cart:open'));
          })
          .catch(function () { form.submit(); })
          .finally(function () {
            addBtn.classList.remove('btn--loading');
            addBtn.disabled = false;
          });
      });
    }
  });

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-cross-sell-add]');
    if (!button || button.disabled) return;
    event.preventDefault();

    var matchVariantId = Number(button.getAttribute('data-variant-id'));
    var matchProductId = button.getAttribute('data-product-id');
    var mainRoot = document.querySelector('[data-product-form]');
    var mainVariantInput = mainRoot && mainRoot.querySelector('[data-variant-id-input]');
    var mainQtyInput = mainRoot && mainRoot.querySelector('[data-qty-input]');
    var mainProductId = mainRoot && mainRoot.getAttribute('data-product-id');
    var mainVariantId = mainVariantInput ? Number(mainVariantInput.value) : 0;
    var mainQuantity = mainQtyInput ? Math.max(1, parseInt(mainQtyInput.value, 10) || 1) : 1;

    if (!matchVariantId || !mainVariantId) return;

    var originalLabel = button.textContent;
    button.disabled = true;
    button.classList.add('btn--loading');

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('cart_read_failed');
        return res.json();
      })
      .catch(function () {
        return { items: [] };
      })
      .then(function (cart) {
        var mainAlreadyInCart = (cart.items || []).some(function (item) {
          return Number(item.variant_id) === mainVariantId;
        });
        var items = [];
        if (!mainAlreadyInCart) {
          items.push({ id: mainVariantId, quantity: mainQuantity });
        }
        items.push({ id: matchVariantId, quantity: 1 });

        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        });
      })
      .then(function (res) {
        if (!res.ok) throw new Error('cross_sell_pair_add_failed');
        return res.json();
      })
      .then(function () {
        button.textContent = 'Pair added';
        window.EleanorAnalytics && EleanorAnalytics.track('cross_sell_pair_add', {
          mainProductId: mainProductId,
          mainVariantId: mainVariantId,
          matchProductId: matchProductId,
          matchVariantId: matchVariantId,
          quantity: mainQuantity
        });
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        document.dispatchEvent(new CustomEvent('cart:open'));
      })
      .catch(function () {
        button.textContent = 'Try again';
      })
      .finally(function () {
        button.classList.remove('btn--loading');
        window.setTimeout(function () {
          button.disabled = false;
          button.textContent = originalLabel;
        }, 1100);
      });
  });

  var originalCta = document.querySelector('[data-original-cta-anchor]');
  var stickyCta = document.querySelector('[data-sticky-cta]');
  if (originalCta && stickyCta && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      stickyCta.setAttribute('data-visible', String(!visible));
      stickyCta.setAttribute('aria-hidden', String(visible));
      if (visible) {
        stickyCta.setAttribute('inert', '');
      } else {
        stickyCta.removeAttribute('inert');
      }
    }, { threshold: 0 });
    observer.observe(originalCta);
  }
  var stickyAddBtn = document.querySelector('[data-sticky-add-to-cart]');
  if (stickyAddBtn) {
    stickyAddBtn.addEventListener('click', function () {
      window.EleanorAnalytics && EleanorAnalytics.track('sticky_cta_click', {});
      var mainAdd = document.querySelector('[data-add-to-cart]');
      if (mainAdd) mainAdd.click();
    });
  }

  document.querySelectorAll('[data-product-gallery]').forEach(function (gallery) {
    var track = gallery.querySelector('[data-gallery-track]');
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-slide]'));
    var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-dot]'));
    var thumbsTrack = gallery.querySelector('[data-gallery-thumbs]');
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));
    var previousButton = gallery.querySelector('[data-gallery-prev]');
    var nextButton = gallery.querySelector('[data-gallery-next]');
    var thumbsPreviousButton = gallery.querySelector('[data-gallery-thumbs-prev]');
    var thumbsNextButton = gallery.querySelector('[data-gallery-thumbs-next]');
    var currentCounter = gallery.querySelector('[data-gallery-current]');
    var counterLabel = gallery.querySelector('[data-gallery-counter-label]');
    var activeIndex = 0;
    var thumbScrollFrame;

    function reducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function ensureThumbVisible(index) {
      var thumb = thumbs[index];
      if (!thumb || !thumbsTrack) return;
      var visibleStart = thumbsTrack.scrollLeft;
      var visibleEnd = visibleStart + thumbsTrack.clientWidth;
      var thumbStart = thumb.offsetLeft;
      var thumbEnd = thumbStart + thumb.offsetWidth;
      if (thumbStart < visibleStart) {
        thumbsTrack.scrollTo({ left: thumbStart, behavior: reducedMotion() ? 'auto' : 'smooth' });
      } else if (thumbEnd > visibleEnd) {
        thumbsTrack.scrollTo({ left: thumbEnd - thumbsTrack.clientWidth, behavior: reducedMotion() ? 'auto' : 'smooth' });
      }
    }

    function updateThumbControls() {
      if (!thumbsTrack) return;
      var maximum = Math.max(0, thumbsTrack.scrollWidth - thumbsTrack.clientWidth);
      var hasOverflow = maximum > 2;
      if (thumbsPreviousButton) thumbsPreviousButton.hidden = !hasOverflow || thumbsTrack.scrollLeft <= 2;
      if (thumbsNextButton) thumbsNextButton.hidden = !hasOverflow || thumbsTrack.scrollLeft >= maximum - 2;
    }

    function updateActive(index) {
      activeIndex = Math.max(0, Math.min(index, slides.length - 1));
      dots.forEach(function (dot, i) { dot.setAttribute('aria-current', String(i === activeIndex)); });
      thumbs.forEach(function (thumb, i) { thumb.setAttribute('aria-current', String(i === activeIndex)); });
      if (currentCounter) currentCounter.textContent = String(activeIndex + 1);
      if (counterLabel) {
        var template = counterLabel.getAttribute('data-counter-template') || '';
        counterLabel.textContent = template.replace('__current__', String(activeIndex + 1));
      }
      if (previousButton) previousButton.disabled = activeIndex === 0;
      if (nextButton) nextButton.disabled = activeIndex === slides.length - 1;
      ensureThumbVisible(activeIndex);
      updateThumbControls();
    }

    function goTo(index, behavior) {
      var targetIndex = Math.max(0, Math.min(index, slides.length - 1));
      var slide = slides[targetIndex];
      if (!slide || !track) return;
      track.scrollTo({
        left: slide.offsetLeft,
        behavior: reducedMotion() ? 'auto' : (behavior || 'smooth')
      });
      updateActive(targetIndex);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goTo(i, 'smooth'); });
    });
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { goTo(i, 'smooth'); });
    });
    if (previousButton) {
      previousButton.addEventListener('click', function () { goTo(activeIndex - 1, 'smooth'); });
    }
    if (nextButton) {
      nextButton.addEventListener('click', function () { goTo(activeIndex + 1, 'smooth'); });
    }
    if (thumbsPreviousButton && thumbsTrack) {
      thumbsPreviousButton.addEventListener('click', function () {
        thumbsTrack.scrollBy({ left: -Math.max(thumbsTrack.clientWidth * 0.65, 160), behavior: reducedMotion() ? 'auto' : 'smooth' });
      });
    }
    if (thumbsNextButton && thumbsTrack) {
      thumbsNextButton.addEventListener('click', function () {
        thumbsTrack.scrollBy({ left: Math.max(thumbsTrack.clientWidth * 0.65, 160), behavior: reducedMotion() ? 'auto' : 'smooth' });
      });
    }
    gallery.addEventListener('gallery:goto', function (event) {
      var detail = event.detail || {};
      goTo(detail.position || 0, detail.behavior || 'smooth');
    });

    if (track && 'IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) updateActive(slides.indexOf(entry.target));
        });
      }, { root: track, threshold: 0.6 });
      slides.forEach(function (slide) { observer.observe(slide); });
    }

    if (track) {
      track.addEventListener('click', function (event) {
        if (event.target.closest('img')) window.EleanorAnalytics && EleanorAnalytics.track('image_interaction', {});
      });
    }

    if (thumbsTrack) {
      thumbsTrack.addEventListener('scroll', function () {
        if (thumbScrollFrame) window.cancelAnimationFrame(thumbScrollFrame);
        thumbScrollFrame = window.requestAnimationFrame(updateThumbControls);
      }, { passive: true });
    }
    window.addEventListener('resize', updateThumbControls);
    updateActive(0);
  });
})();
